
import {STORAGE_KEY} from './Constants'

export const saveInLocalStorage = (key: string, value: string) => {
    localStorage.setItem(key, value);
  };
  export const removeFromLocalStorage = (key: string) => {
    localStorage.removeItem(key);
  };
  export const getFromLocalStorage = (key: string) => {
    const data = localStorage.getItem(key);
    return data ?? '';
  };
  
  export const getAccessToken = () => {
    const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
    if (data) {
      const user: LoggedUserType = JSON.parse(data);
      return user.accessToken;
    }
    return '';
  };
  
  export const clearSession = () => {
    sessionStorage.clear();
  };
//   export const getUser = (): LoggedUserType => {
//     let user: LoggedUserType = loginMockData.user;
//     const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
//     if (data) {
//       user = JSON.parse(data);
//     }
//     return user;
//   };